// extracted by mini-css-extract-plugin
module.exports = {"section":"JhxSB","list":"_77alt","listItem":"_3nEAv","link":"_3wZaf","active":"_1Ilja"};